import React, { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { Table, Spin, Popconfirm } from "antd";
import { connect } from "react-redux";
import { Grid, Button } from "@mui/material";
import { IoMdAddCircle } from "react-icons/io";
import { FaRegEdit } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { dispatch } from "store/index";
import { GetAllTenants, EditTenantStatus } from "store/action/index";
import { toast } from "react-toastify";
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB"); // UK format: 16/09/2025
};

const AllTenants = ({ getAllTenants }) => {
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 100,
  });

  useEffect(() => {
    if (getAllTenants && getAllTenants?.tenants) {
      setDataSource(getAllTenants?.tenants);
    }
  }, [getAllTenants]);

  useEffect(() => {
    dispatch(GetAllTenants({ setLoading }));
  }, []);

  const handleEdit = (data) => {
    navigate("/tenants/add-tenant", { state: data });
  };

  const handleStatusChange = (record) => {
    const newStatus = record.status === "active" ? "inactive" : "active";
    const payload = { id: record.id, status: newStatus };

    dispatch(
      EditTenantStatus({
        payload,
        setLoading,
        onSuccess: () => {
          toast.success(`Tenant ${newStatus} successfully`);
          dispatch(GetAllTenants({ setLoading }));
        },
        onError: (err) => toast.error(err || "Status update failed"),
      })
    );
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Domain",
      dataIndex: "domain",
      key: "domain",
      render: (text) => (
        <a href={`https://${text}`} target="_blank" rel="noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      render: (text) => text.replace(/_/g, " "), // prettify plan value
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render:  (text,record) => record.plan?.includes('percent')?` ${Math.round(+text)}%`:` ${text} `,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
    },
    {
      title: "Database Name",
      dataIndex: "db_name",
      key: "db_name",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
       render: (text) => formatDate(text),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <span style={{ display: "flex", gap: "8px" }}>
          {/* view reports */}
          <Link to={`/tenants/view-tenant-report/${record.id}`}>
            <Button color="primary" variant='outlined'>View Report</Button>
          </Link>
          {/* Edit */}
          
          {/* Activate/Deactivate */}
          <Popconfirm
            title={`Are you sure you want to ${
              record.status === "active" ? "deactivate" : "activate"
            } this tenant?`}
            onConfirm={() => handleStatusChange(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              variant="outlined"
              color={record.status === "active" ? "error" : "success"}
            >
              {record.status === "active" ? "Deactivate" : "Activate"}
            </Button>
          </Popconfirm>

          <Button onClick={() => handleEdit(record)} color="primary"
            
            variant='outlined'
            >
            <FaRegEdit />
          </Button>

        </span>
      ),
    },
  ];

  const handleTableChange = (paginationTable) => {
    setLoading(true);
    setPagination(paginationTable);
  };

  return (
    <>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          height: "67px",
          borderRadius: "10px",
          marginBottom: "20px",
          padding: "0 16px",
          backgroundColor: "#fff",
        }}
      >
        <Grid container alignItems="center" justifyContent="flex-start">
          <Grid item>
            <span style={{ fontSize: "22px", fontWeight: "600" }}>
              All Tenants
            </span>
          </Grid>
        </Grid>
        <Grid container alignItems="center" justifyContent="flex-end">
          <Grid item>
            <Link to={"/tenants/add-tenant"}>
              <Button className="px-2" size="large" type="submit">
                <span className="mx-2">
                  <IoMdAddCircle color="#3B99E3" size={26} />
                </span>
                Add Tenant
              </Button>
            </Link>
          </Grid>
        </Grid>
      </div>

      {/* Table Section */}
      <MainCard>
        <Spin spinning={loading}>
          <Table
            dataSource={dataSource}
            columns={columns}
            onChange={handleTableChange}
            rowKey="id"
          />
        </Spin>
      </MainCard>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getAllTenants: state?.GetAllTenants?.getAllTenants,
  };
};

export default connect(mapStateToProps)(AllTenants);
